<template>
  <div class="card shadow m-3 position-fixed right-0 top-0" style="z-index: 1">
    <div style="width: 456px" class="card-body d-flex align-items-center">
      <div
        :class="{ rotate: !complete }"
        class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary"
        style="width: 50px; height: 50px"
      >
        <i class="fa-solid fa-hourglass-half fa-2x" />
      </div>

      <div style="width: 80%">
        <div class="progress rounded-round mb-2" style="height: 12px">
          <div
            class="progress-bar bg-primary rounded-round"
            :style="`width:${progressBarWidth}%;`"
          />
        </div>
        <div>
          <!-- {{ $t('Updating shipment status 5 shipment from 5 shipments.') }} -->
          {{$t('Updating shipment status {countShipmentS} shipment from {countShipmentE} shipments.') | replaceText(countItemS,countItem) }}
        </div>

        
      </div>
      <button
        :class="{ 'text-muted': !isClose }"
        @click="close()"
        type="button"
        class="close align-self-start ml-2 mr-n1 mt-n2"
      >
        <span>×</span>
      </button>
    </div>
  </div>
</template>

<script>

import Api from "@/services/endpoint/tenant.service.js";
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      progressBarWidth: 0,
      showLogError: false,
      complete: false,
      isClose: false,
      tenant: {},
      countItem: 0,
      countItemS:0,

    };
  },
  methods: {
    close() {
      this.$store.dispatch("shipment/isProgressBarUpdateShipment", false);
    },
    async updateStatus() {
      let dataUpdateShipment = this.$store.state.shipment.dataUpdateShipment;

      this.countItem = dataUpdateShipment.countTrue;
      let order_id = dataUpdateShipment.order_id;
      let activeTab = dataUpdateShipment.activeTab;
      let dataCookie = dataUpdateShipment.dataCookie;

      if(dataUpdateShipment.countTrue){
        try {
          let dataSubmit = {
            "viewpoint" : activeTab,
            "shipment_ids" : order_id,
          }
          
          let response = await Api.ShipmentV2.requestUpdate(dataSubmit);

          if(response.data.data.success){
            this.countItemS = this.countItem;
            this.progressBarWidth = 100;
            setTimeout(() => {
              Cookies.set('orderUpdateStatus', JSON.stringify(dataCookie), { domain: '.' + process.env.CENTRAL_API_ROOT });
              this.$store.dispatch("shipment/isProgressBarUpdateShipment", false);
              this.$toastr.s(this.$t('Update Status Success.'), "<span class='fa-solid fa-circle-check'></span>" + this.$t("Success"));
            }, 1000);
          }
        }catch(err) {
          this.$store.dispatch("shipment/isProgressBarUpdateShipment", false);
          this.$toastr.e(
            this.$t("Update Status Failed."),
            "<i class='fa fa-circle-xmark'></i> " + this.$t("Failed")
          );
        }
      }else{
        this.$store.dispatch("shipment/isProgressBarUpdateShipment", false);
        this.$toastr.e(
          this.$t("Update Status Failed."),
          "<i class='fa fa-circle-xmark'></i> " + this.$t("Failed")
        );
      }
      
     
    },
   
  },
  mounted() {
    setTimeout(() => {
      this.progressBarWidth = 50;
      }, 500);

      this.updateStatus();

  },
  beforeDestroy() {
    this.close();
  },
  watch: {
   
  },
  filters: {
    replaceText: function (text, value,value2) {
          text = text.replace('{countShipmentS}', value || 0);
          text = text.replace('{countShipmentE}', value2 || 0);
      
        return text;
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ProgressBarUpdateShipment.vue